import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { cn } from '@/lib/styles';
import styles from '../featureComparison/FeatureCell.module.css';
export function BillingDetails(t0) {
  const $ = _c(12);
  const {
    pricingItem,
    yearly: t1,
    className
  } = t0;
  const yearly = t1 === undefined ? false : t1;
  const t = useTranslations("Pricing");
  const price = yearly ? pricingItem?.priceBilledYearly ?? pricingItem?.priceBilledMonthly : pricingItem?.priceBilledMonthly;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex flex-col gap-2.5 px-3.75 pb-5 text-neutral-light-100 h-full", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== price || $[3] !== t) {
    t3 = price != null && <div className="lok-text-display-medium">{t("dollar")}{price}<span className="lok-text-heading-large">{t("mo")}</span></div>;
    $[2] = price;
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== pricingItem || $[6] !== yearly) {
    t4 = yearly && pricingItem?.priceUnderline ? <div className="mt-auto"><CkEditorCSRRenderer htmlContent={pricingItem.priceUnderline} className={cn(styles["table-cell-content"], "xl:whitespace-nowrap")} defaultTypography="bodyMedium" /></div> : null;
    $[5] = pricingItem;
    $[6] = yearly;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}